import { defineMessages } from 'react-intl';

export default defineMessages({
  Vat: {
    defaultMessage: '({price} incl. VAT)',
    description: 'Price VAT text',
    id: 'price.Vat',
  },
});
